import { ApiCancellationReason, ApiOrderCancellationActor } from '@/core/generated/api';
import type { TableViewState } from '@/shared/lib/tableViewState';
import { FilterMatchMode } from 'primereact/api';

/** Значения причин для фильтра отменённых заказов */
export const CANCELLATION_REASON_OPTIONS = [
    {
        label: 'Не указана',
        value: ApiCancellationReason.Undefined
    },
    {
        label: 'Передумал',
        value: ApiCancellationReason.ChangedMyMind
    },
    {
        label: 'Слишком долго ждать',
        value: ApiCancellationReason.TooLongWait
    },
    {
        label: 'Исполнитель стоит на месте',
        value: ApiCancellationReason.ExecutorStandsStill
    },
    {
        label: 'Исполнитель не выходил на связь',
        value: ApiCancellationReason.ExecutorDidNotGetInContact
    },
    {
        label: 'Исполнитель попросил отменить',
        value: ApiCancellationReason.ExecutorAskedToCancel
    },
    {
        label: 'Другая причина',
        value: ApiCancellationReason.Custom
    },
    {
        label: 'Не найден исполнитель',
        value: ApiCancellationReason.AutoCancelNoExecutor
    },
    {
        label: 'Не завершено оформление',
        value: ApiCancellationReason.AutoCancelNotCompleted
    },
    {
        label: 'Клиент отменил поиск исполнителя',
        value: ApiCancellationReason.ClientCancelNoExecutor
    },
];

/** Значения инициаторов для фильтра отменённых заказов */
export const CANCELLATION_INITIATOR_OPTIONS = [
    {
        label: 'Не определён',
        value: ApiOrderCancellationActor.Undefined
    },
    {
        label: 'Клиент',
        value: ApiOrderCancellationActor.Client
    },
    {
        label: 'Исполнитель',
        value: ApiOrderCancellationActor.Executor
    },
    {
        label: 'Система',
        value: ApiOrderCancellationActor.System
    },
];

/** Начальные фильтры, страница и сортировка таблицы отмен */
export const CANCELLATION_TABLE_DEFAULTS: TableViewState = {
    filters: {
        orderNumber: {
            value: null,
            matchMode: FilterMatchMode.CONTAINS
        },
        reason: {
            value: null,
            matchMode: FilterMatchMode.IN
        },
        description: {
            value: null,
            matchMode: FilterMatchMode.CONTAINS
        },
        initiator: {
            value: null,
            matchMode: FilterMatchMode.IN
        },
        cancelledAt: {
            value: null,
            matchMode: FilterMatchMode.CUSTOM
        },
    },
    search: '',
    first: 0,
    rows: 50,
    sortField: 'cancelledAt',
    sortOrder: -1,
};
